module.exports = __webpack_public_path__ + "static/qxy-8dbc5f0a7880f8def3e0eb3bb973f612.jpg";